export const DEFAULT_PROGRESS = 0;
